import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';
import { NetService } from './net.service';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

constructor(
  private netService: NetService
) { }

  checkContactType(phone: string) {
    return this.netService.getJavaUser(`users/find-all-by?mobilePhone=${phone}`)
  }


  createCandidate(body: any) {
    return this.netService.postJavaCandidate('candidate/create-candidate', body)
  }


  createTicket(body: any) {
    return this.netService.postJavaNotification('service-board/ticket',body)
  } 

  geServiceCategories() {
    return this.netService.getJavaNotification(`ticket-category/get-all`)
  }

  getTenantData(tenatnId: string) {
    return this.netService.getJavaUser(`tenant/${tenatnId}`)
  }

  getOwnerData(ownerId: string) {
    return this.netService.getJavaUser(`tenant/get-companies-by-contact/${ownerId}`)
  }

  getOwnerProperites(ownerId: string) {
    return this.netService.getJavaUser(`property/get-properties?tenantStatus=all&ownerStatus=All&contextLocation=all&propertyType=4&managerId=all&ownerAccountId=${ownerId}&isOsb=true`)

    // https://app-dev.home365.co/training/tenant/tenant/company-details?propertyId=0bc78c92-702f-46e8-8d94-2b400ad44355&userId=14f478fc-fc58-44bd-a043-3b43d75e9f01&tzOffset=%252B03:00
  }

  
}
